import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ChoiceButtonBaseIcon } from "../../../../../../shared/ChoiceButton";
import { TravelTypeButton } from "../../../../../../shared/TravelTypeButton";
import { TravelSegmentType } from "../../../../shared/types/travelSegment";

interface Props {
	availableTypes: TravelSegmentType[];
	activeType: TravelSegmentType | null;
	onChange: (type: TravelSegmentType | null) => void;
}

const FilterButtonGroup = styled.div`
	display: grid;
	gap: ${({ theme }) => theme.spacing(2)};
	grid-template-columns: 1fr 1fr;

	${({ theme }) => theme.breakpoints.tablet} {
		grid-auto-flow: column;
		grid-auto-columns: 1fr;
	}
`;

export const TravelSegmentTypeFilterBar: FC<Props> = ({ availableTypes, activeType, onChange }) => {
	const { t } = useTranslation();
	const toggleFilterByType = (type: TravelSegmentType) => {
		if (activeType === type) {
			onChange(null);
		} else {
			onChange(type);
		}
	};

	if (availableTypes.length <= 1) {
		return null;
	}

	return (
		<FilterButtonGroup>
			{availableTypes.includes("flight") && (
				<TravelTypeButton
					type="button"
					aria-label={t("Show only flights")}
					onClick={() => toggleFilterByType("flight")}
					aria-pressed={activeType === "flight"}
				>
					<ChoiceButtonBaseIcon src="/icons/travel.svg" />
					{t("flight")}
				</TravelTypeButton>
			)}
			{availableTypes.includes("train") && (
				<TravelTypeButton
					type="button"
					aria-label={t("Show only trains")}
					onClick={() => toggleFilterByType("train")}
					aria-pressed={activeType === "train"}
				>
					<ChoiceButtonBaseIcon src="/icons/train.svg" />
					{t("train")}
				</TravelTypeButton>
			)}
			{availableTypes.includes("car") && (
				<TravelTypeButton
					type="button"
					aria-label={t("Show only cars")}
					onClick={() => toggleFilterByType("car")}
					aria-pressed={activeType === "car"}
				>
					<ChoiceButtonBaseIcon src="/icons/car.svg" />
					{t("car")}
				</TravelTypeButton>
			)}
			{availableTypes.includes("shuttle") && (
				<TravelTypeButton
					type="button"
					aria-label={t("Show only shuttles")}
					onClick={() => toggleFilterByType("shuttle")}
					aria-pressed={activeType === "shuttle"}
				>
					<ChoiceButtonBaseIcon src="/icons/shuttle.svg" />
					{t("shuttle")}
				</TravelTypeButton>
			)}
		</FilterButtonGroup>
	);
};
